module.exports = "/images/nu.svg?0e051a5af58b856a44b8632fa333bd1a";